import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-add-content-tabs',
    imports: [],
    templateUrl: './tabs.component.html',
    styleUrl: './tabs.component.scss',
})
export class TabsComponent {
    /** The list of tabs to display. */
    public tabs = input.required<{ id: number; label: string; iconKey: string }[]>();

    /** The ID of the currently active tab. */
    public currentTab = input.required<number>();

    /** Emits the tab ID when a tab is clicked. */
    public tabClick = output<number>();

    /**
     * Handles tab click and emits the selected tab ID.
     *
     * @param tabId - The ID of the clicked tab.
     */
    protected onTabClick(tabId: number): void {
        this.tabClick.emit(tabId);
    }
}
